import React, { useState } from 'react';

import styles from './PerkCard.module.scss';

const {
  'perk-card': perkCardClass,
  'perk-modal': perkModalClass,
  'modal-body': modalBodyClass,
  'modal-header': modalHeaderClass
} = styles;

const PerkCard = ({
  perkIcon,
  perkTitle,
  perkSubtitle,
  buttonCopy,
  modalHeaderCopy,
  modalBodyCopy
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  return (
    <div className={perkCardClass}>
      <img src={perkIcon} alt="perk icon" />
      <h4>{perkTitle} </h4>
      <p>{perkSubtitle}</p>
      <button onClick={() => setModalOpen(true)}>{buttonCopy}</button>
      {isModalOpen && (
        <div className={perkModalClass}>
          <div className={modalBodyClass}>
            <div className={modalHeaderClass}>
              <button onClick={() => setModalOpen(false)}>X</button>
              <img src={perkIcon} alt="perk icon" />
              <h3>{modalHeaderCopy}</h3>
              <p>{modalBodyCopy}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PerkCard;
